<template>
    <div
        class="ds-form-group"
        :class="{ disabled: disabled, 'theme--dark': theme === 'dark' }"
        :disabled
        role="group"
        :aria-labelledby="headerId"
    >
        <h4 v-if="header" class="ds-form-group__header" :id="headerId">{{ header }}</h4>
        <slot v-bind="itemAttrs"></slot>
    </div>
</template>

<script lang="ts" setup generic="T extends DsFormFieldValueType[]">
import { DsFormFieldValueType } from "../../models/ds-form-field-models";
import type { Theme } from "../../../types/theme";
import { computed, reactive } from "vue";

const props = defineProps<{
    name: string;
    header?: string;
    disabled?: boolean;
    theme?: Theme;
}>();

const headerId = computed(() => (props.header ? `label-${props.name}` : null));

const itemAttrs = reactive({
    class: "ds-form-group__item",
});
</script>
